import styled from "styled-components";

const ViewCartStyle = styled.div`
.container {
  max-width: 1672px;
  width: 100%;
}
  & .main_viewCart_section_class {
    height: 100%;
    &.cart-sec {
      padding: 60px 0 85px !important;
      margin-top: 45px;
      @media (max-width:1199px){
        padding: 50px 0 60px !important;
      }
      h1 {
        font-weight: 600;
        font-size: 26px;
        text-transform: uppercase;
        text-align:center;
      }
    }
    .table_container {
      height: 100%;
      max-height: 950px;
      overflow-y: auto;
      .whistlist-table {
        width: 100%;
        /* border: 1px solid rgb(221, 221, 221);  */
        /* border-radius: 40px; */
        height: 45px;
        /* max-width: 200px; */
        background: #fff;
        padding: 0 10px;
        tr {
          &.checkout-btn + tr {
            background: #fff;
          }
          &:nth-child(2n) {
            background: #f9f9f9;
          }
          &.checkout-btn {
            width: 100%;
            float: none;
            ul {
              padding: 0;
              margin: 40px 57px 40px 0;
              list-style: none;
              width: 19%;
              float: right;
              /* max-width: max-content; */
              @media (max-width: 991px) {
                margin: 20px 0;
              }
            }
            button {
              min-width: 308px;
              border-radius: 25px;
              font-size: 17px;
              font-weight: 600;
              height: 47px;
              background: #06356a;
              border: none;
            }
          }
          th {
            text-align: center;
            background: #06356a;
            color: #fff;
            text-transform: uppercase;
            padding: 15px 0;
            position: sticky;
            top: 0;
            z-index: 9;
            text-align: center !important;
            /* &:first-child {
              border-top-left-radius: 0px;
            }
            &:last-child {
              border-top-right-radius: 0px;
            } */
              @media (max-width: 1199px) {
              font-size: 14px;
            }
            &:nth-child(4) {
              min-width: 90px;
            }
            @media (max-width: 991px) {
              padding: 12px;
            }
          }

          td {
            text-align: center;
            .main-qty-sec {
              margin: 13px -15px 15px;
              display: flex;
              justify-content: center;
              @media (max-width: 991px) {
                justify-content: center;
                margin: 0 auto;
              }
            }
            select {
              width: 155px;
              height: 40px;
              border: 1px solid #ddd;
              border-radius: 50px;
              background: transparent;
              padding: 0 10px;
              font-size:16px;
              text-align:center;
              margin:auto;
              margin-bottom: 0 !important;
            }
            #qty {
              @media (max-width: 991px) {
                justify-content: center;
              }
              input {
                background: #fff;
                width: 40px !important;
                border-right: 1px solid var(--blue);
                border-left: 1px solid var(--blue);
              }
              button {
                width: 38px;
              }
              /* .sub {
                left: -2px;
                top: -4px !important;
              }
              .add {
                top: -4px !important;
              } */
            }
            /* &:not(:first-child) {
              border-left: 1px solid #f9f9f9;
            } */
          }
        }

        .cart-product-details {
          display: flex;
          align-items: center;
          justify-content: center;
          button {
            border-radius: 50px;
            width: 30px;
            background: #e7f2ff;
            max-width: 30px;
            min-width: 30px;
            height: 30px;
            margin-left: 10px;
            font-size: 12px;
            color: #06356a;
          }
        }
        .Add_to_cart button {
          font-size: 13px !important;
          font-weight: 600;
          border-radius: 50px;
        }
        .pro-cart-table {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .checkout_button {
          float: right;
          margin: 0 50px 20px 0;
          @media (max-width: 991px) {
            margin: 0;
          }
          button {
            min-width: 316px;
            height: 49px;
            border-radius: 25px;
            font-weight: 600;
            font-size: 18px;
            background: #06356a;
            border: 2px solid #06356a;
            &:hover {
              background: #fff;
              color: #06356a;
            }
            @media (max-width: 767px) {
              min-width: 120px;
              height: 42px;
              font-size: 14px;
            }
          }
        }
      }
      @media (max-width: 991px) {
        overflow-x: auto;
      }
      @media (max-width: 767px) {
        overflow-x: visible;
        .checkout-btn td {
          padding-left: 0 !important;
        }
        .checkout-btn td:before {
          display: none !important;
        }
        tr.checkout-btn ul {
          margin: 20px 0;
          width: 100%;
        }
      }
    }
  }
  .mini-cart-sec
    .mini-cart
    .min-cat-uppper
    .mini-cart-des
    .main-qty-sec
    .box
    #qty {
    max-width: 80% !important;
    border: 0px solid #ddd;
    display: flex;
    margin-top: 0 !important;
  }
  table.Cart_product.whistlist-table .main-qty-sec {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }

  table.Cart_product.whistlist-table .main-qty-sec .box {
    padding: 0;
    min-width: 120px;
  }

  /*Cart
https://ccmlm.com
*/

  @media (max-width: 1440px) {
    .main_viewCart_section_class .table_container .whistlist-table tr td #qty {
      display: flex !important;
    }
    .main_viewCart_section_class .main-qty-sec .box #qty button {
      height: 28px !important;
    }
  }
  @media (max-width: 1024px) {
    .main-qty-sec .box {
      max-width: 100% !important;
      flex: 0 0 100% !important;
    }
  }

  @media (max-width: 480px) {
    table.Cart_product.whistlist-table th {
      min-width: 250px;
    }
  }

  .cart-image img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

#qty {

    flex-wrap: unset !important;
}

.main-qty-sec .box:last-child {
  display: flex;
  align-items: center;
}

.main-qty-sec .box:last-child span {
  max-width: 42%;
  flex: 0 0 42%;
  -ms-flex: 0 0 42%;
}


table.Cart_product.whistlist-table {
  width: 100%;
  max-width: 100%;
  text-align: left;
  margin-bottom: 0;
}

table.Cart_product.whistlist-table tr:not(:last-child) td {
  border-bottom: none
}

table.Cart_product.whistlist-table td:not(:last-child) {
  border-right: none
}


table.Cart_product.whistlist-table tr td {
  padding: 15px 20px;
}

table.Cart_product.whistlist-table th {
  text-align: left !important;
}

 .main_viewCart_section_class .table_container .whistlist-table tr td {
    text-align: center;
}
.cart-product-qty-del button {
  background: transparent !important;
  color: red;
  padding: 0;
  border: unset !important;

}

.checkout-btn ul li {
  text-align: right;
  padding: 0 0 15px;
  margin: 0 0 15px;
  border-bottom: 1px solid #ddd;
}
  .checkout-btn ul li:last-child {
  border-bottom: 0;
  padding: 0;
  margin: 0;
}

.checkout-btn ul li strong {
  float: left;
  font-weight: 600;
  text-transform: uppercase;
}

@media (max-width:1199px){
  .checkout-btn ul {
    max-width: 250px;
    width: 100% !important;
}
}






.main-qty-sec .box:last-child {
  display: flex;
  align-items: center;
}

.main-qty-sec .box:last-child span {
  max-width: 42%;
  flex: 0 0 42%;
  -ms-flex: 0 0 42%;
}

.main-qty-sec .box:last-child #qty {
  max-width: 70%;
  flex: 0 0 70%;
  -ms-flex: 0 0 70%;
  margin-top: 0;
}

.main-qty-sec .box #qty {
  position: relative;
  border: 1px solid var(--blue);
  align-items: center;
}

.main-qty-sec .box #qty input {
  width: 20%;
  border: 0;
  height: 37px;
  text-align: center;
  background: #fff;
}

.Cart_product .row {
  border-bottom: 1px solid #ddd;
  padding-bottom: 15px;
  margin-bottom: 15px;
  align-items: center;
}

.main-qty-sec .box #qty button {
  /* position: absolute; */
  top: 0;
  bottom: 0;
  width: 22px;
  height: 37px;
  background: transparent;
  color: #000;
  border: 0;
  padding: 0;
}

table.Cart_product.whistlist-table tr:not(:last-child) td {
  border-bottom: none
}

table.Cart_product.whistlist-table td:not(:last-child) {
  border-right: none
}


table.Cart_product.whistlist-table tr td {
  padding: 15px 20px;
}

table.Cart_product.whistlist-table th {
  text-align: left !important;
}
    `;



const SecondTableCss = styled.div`
  margin-top: 40px;
  .heading_of_pack {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background: #06356b;
    color: #fff;
    font-size: 15px;
    font-weight: 600;

    @media (max-width: 767px) {
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
    }
    .title_of_pack {
      padding: 15px;
      font-size: 18px;
      width: 100%;
    }
    .amount_and_edit {
      display: flex;
      flex-flow: nowrap;
      gap: 20px;
    }
    .button_for_edit {
      display: flex;
      gap: 20px;
      div {
        padding: 15px;
      }
    }
    .amount {
      padding: 18px;
      margin-right: 0;
    }
    @media (max-width: 767px) {
      h3.title {
        margin: 10px;
      }
    }
  }
  .table_container {
    margin-top: 10px;
    @media (max-width: 991px) {
      overflow-x: auto;
    }
    table {
      tr {
        th {
          text-align: center;
          padding: 15px 20px;
          background: #06356b;
          color: #fff;
        }
        td {
          padding: 15px 0px;
        }
      }
    }
  }

  .Cart_product div#qty {
  max-width: 100% !important;
  flex: 0 0 100% !important;
  -ms-flex: 0 0 70%;
}

#qty {

    flex-wrap: unset !important;
}

.main-qty-sec .box:last-child {
  display: flex;
  align-items: center;
}

.main-qty-sec .box:last-child span {
  max-width: 42%;
  flex: 0 0 42%;
  -ms-flex: 0 0 42%;
}


`;

export default ViewCartStyle;
export { SecondTableCss };
